<template>
  <div class="form-grid">
    <div class="form-column">
      <div class="form-row">
        <div class="form-group">
          <label>Fees:</label>
          <div class="input-group">
            <i class="fa-solid fa-user"></i>
            <input
              :value="doctor.consultationFee"
              @input="updateField('consultationFee', $event.target.value)"
              type="number"
              placeholder="500"
            />
          </div>
          <p v-if="errors.consultationFee" class="error">
            {{ errors.consultationFee }}
          </p>
        </div>

        <div class="form-group">
          <label>Working Days:</label>
          <div class="input-group">
            <i class="fa-solid fa-user"></i>
            <input
              :value="doctor.workingDays"
              @input="updateField('workingDays', $event.target.value)"
              type="text"
              placeholder="Mon-Fri"
            />
          </div>
          <p v-if="errors.workingDays" class="error">
            {{ errors.workingDays }}
          </p>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>Timing:</label>
          <div class="input-group">
            <i class="fa-solid fa-user"></i>
            <input
              :value="doctor.sittingTime"
              @input="updateField('sittingTime', $event.target.value)"
              type="text"
              placeholder="2:00 PM - 5:00 PM"
            />
          </div>
          <p v-if="errors.sittingTime" class="error">
            {{ errors.sittingTime }}
          </p>
        </div>

        <div class="form-group">
          <label>External Systems Id <span class="text-muted">(Optional)</span></label>
          <div class="input-group">
            <i class="fa-solid fa-id-card"></i>
            <input
              :value="doctor.reference"
              @input="updateField('reference', $event.target.value)"
              type="text"
              placeholder="e.g. aprPXYZ"
            />
          </div>
          <p v-if="errors.reference" class="error">
            {{ errors.reference }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DoctorSummaryForm",
  props: {
    doctor: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:doctor"],
  methods: {
    updateField(field, value) {
      this.$emit("update:doctor", {
        ...this.doctor,
        [field]: value,
      });
    },
  },
};
</script>

<style scoped>
.form-grid {
  display: flex;
  flex-direction: column;
}

.form-column {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.form-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}

.form-group {
  flex: 1;
}

.fa-solid {
  font-size: 27px !important;
}

.form-grid .form-group label {
  display: block;
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 600;
}

.form-grid .input-group {
  display: flex;
  align-items: center;
  width: 100%;
}

.form-grid .input-group i {
  background-color: #3c78f9;
  color: #fff;
  padding: 12px;
  font-size: 18px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.form-grid .input-group input {
  flex: 1;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
}

.form-grid .error {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* Chrome, Safari, Edge, Opera */
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
